import { render, staticRenderFns } from "./PhoneConfirmRegistr.vue?vue&type=template&id=3b93170d&"
import script from "./PhoneConfirmRegistr.vue?vue&type=script&lang=js&"
export * from "./PhoneConfirmRegistr.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports